<template>
    <div>
        <!-- <v-alert :color="$root.themeColor" style="border-radius:0;position:sticky;top:0;z-index:1" dense type="info" :value="true">
            Choose attendee to chat with
        </v-alert> -->
        <v-toolbar class="attendeelist_toolbar" :color="$root.themeColor" flat style="color:#fff" extended extension-height="62">
            <v-btn :color="$root.themeColor" icon class="mr-4 white--text" @click="$router.go(-1)">
                <v-icon>{{$root.platform === 'ios' ? 'arrow_back_ios' : 'arrow_back'}}</v-icon>
            </v-btn>
            <v-toolbar-title>Attendees</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <div class="pr-4 pt-0 include_guest_btn"><v-switch hide-details @change="fn_isShowGuest" v-model="IsShowGuest" label="Include Guest"></v-switch></div> -->
            <!-- <v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="#f69220" overlap>
                  <v-icon color="white" @click="$root.fn_openChatView">chat</v-icon>
            </v-badge> -->
            <!-- <div slot="extension" solo><v-switch @change="fn_isShowGuest" v-model="IsShowGuest" label="Include Guest"></v-switch></div> -->
            <v-text-field dense grey-back clearable flat solo hide-details placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch" slot="extension"></v-text-field>
            
        </v-toolbar>
  
        <div>
  
          <template v-if="!error">
            <v-list class="pa-0" three-line>
              <template v-for="(item, index) in winners">
                <v-list-item :key="index" class="zindex2 attendeelist_customformatting">
  
                  <v-list-item-avatar @click="fn_gotoChatPage(item.AttendeeRegistrationID)" class="grey lighten-3" style="align-self: center;">
                      <!-- {{fn_abbreviatedName(item.WinnerName)}} -->
                      <template v-if="item.ImageUrl != null"><v-img alt="winnerimage" :src="item.ImageUrl" lazy-src="../assets/person.svg"></v-img></template>
                      <template v-else>{{fn_abbreviatedName(item.AttendeeName)}}</template>
                      
                  </v-list-item-avatar>
  
                  <v-list-item-content @click="fn_gotoChatPage(item.AttendeeRegistrationID)">
                      <v-list-item-title v-text="item.AttendeeName"></v-list-item-title>
                      <v-list-item-subtitle v-if="item.AttendeeType == 2 && item.PrimaryAttendeeName">Guest of {{item.PrimaryAttendeeName}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.JobTitle">{{item.JobTitle}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.AreaName">{{item.AreaName}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.Subsidiary && item.AreaName != item.Subsidiary">{{item.Subsidiary}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.RegistrationFormType != 1 && item.Organization != null">{{item.Organization}}</v-list-item-subtitle>
  
                  </v-list-item-content>
  
                    <!-- <v-list-item-icon v-if="item.CanChat" style="margin: auto;" @click="$root.fn_openChatView('instantchat', item.AttendeeID)">
                      <v-icon>mdi-message-outline</v-icon>
                    </v-list-item-icon> -->
                  </v-list-item>
  
                  <v-divider inset :key="index+'divider'" v-if="index != winners.length - 1"></v-divider>
              </template>
                
  
                <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
                  <div slot="no-more"></div>
                  <div slot="no-results" class="pa-4 light-opacity-color">No attendee found!</div>
                </infinite-loading>
            </v-list>
          </template>
  
          <template v-else>
            <div style="text-align:center;" class="pa-4">
                <p>Something went wrong. Please try again.</p>
                <br>
                <v-btn outlined @click="fn_debounceSearch"><v-icon left>refresh</v-icon> Retry</v-btn>
            </div>
          </template>
        </div>
  
        <v-dialog v-model="contentDialog" scrollable transition="dialog-bottom-transition" fullscreen persistent>
          <v-card>
            <v-card-title :style="{ backgroundColor: $root.themeColor}" :color="$root.themeColor"  class="title pb-4 pl-4 white--text" style="flex-wrap:nowrap;word-break: break-word;">
                <v-btn :color="$root.themeColor" icon class="mr-4 white--text" @click="contentDialog = false">
                    <v-icon>{{$root.platform === 'ios' ? 'arrow_back_ios' : 'arrow_back'}}</v-icon>
                </v-btn>
                Registration Details
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="scrollable-content form_dialog_text pa-0 platinumclub_custom_formatting">
              <template v-if="error">
                <div style="text-align:center;" class="pa-4">
                    <p>Something went wrong. Please try again.</p>
                    <br>
                    <v-btn outlined @click="fn_getAttendeeInfo"><v-icon left>refresh</v-icon> Retry</v-btn>
                </div>
              </template>

              <template v-if="loading">
                  <div class="pa-8">
                      <v-img width="120" style="margin:auto" src="../assets/giphy.gif"></v-img>
                  </div>
              </template>

              <template v-else>
                <v-card flat class="mt-0" v-if="ItemObj">
                  <v-card-text>
                    <v-card class="height100 details_box" v-if="ItemObj.PrimaryAttendee">
                      <v-card-title style="line-height: 1;" class="dialog_toolbar">Primary Attendee</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pl-2 pb-2 pr-2 pt-2">
                          <div class="form_content height100">
                              <div class="page_content_fields pl-5 pt-2">
                                <div v-if="ItemObj.PrimaryAttendee.RegistrationFormType != 3">
                                    <p class="mb-1" v-if="ItemObj.PrimaryAttendee.BadgeFirstName"><b>Name Badge First and Last Name: </b></p>
                                    <p class="mb-2" v-if="ItemObj.PrimaryAttendee.BadgeFirstName">{{ItemObj.PrimaryAttendee.BadgeFirstName}} {{ItemObj.PrimaryAttendee.BadgeLastName != null ? ItemObj.PrimaryAttendee.BadgeLastName : ''}}</p>
                                    <p class="mb-1" v-if="$root.tripSiteId == 18 && ItemObj.PrimaryAttendee.FirstName"><b>First Name and Last Name: </b></p>
                                    <p class="mb-2" v-if="$root.tripSiteId == 18 && ItemObj.PrimaryAttendee.FirstName">{{ItemObj.PrimaryAttendee.FirstName}} {{ItemObj.PrimaryAttendee.LastName != null ? ItemObj.PrimaryAttendee.LastName : ''}}</p>
                                </div>
                                <div v-else>
                                    <p class="mb-1" v-if="ItemObj.PrimaryAttendee.FirstName"><b>First Name and Last Name: </b></p>
                                    <p class="mb-2" v-if="ItemObj.PrimaryAttendee.FirstName">{{ItemObj.PrimaryAttendee.FirstName}} {{ItemObj.PrimaryAttendee.LastName != null ? ItemObj.PrimaryAttendee.LastName : ''}}</p>
                                </div>
                                  
                                
                                  <div v-if="ItemObj.PrimaryAttendee.PersonalConsiderations && ItemObj.PrimaryAttendee.PersonalConsiderations.DietaryRequirements && ItemObj.PrimaryAttendee.PersonalConsiderations.DietaryRequirements.length>0">
                                      <p class="mb-1"><b>Special Dietary Request:</b></p>
                                      <p class="mb-1" v-if="ItemObj.PrimaryAttendee.PersonalConsiderations.DietaryRequirements && ItemObj.PrimaryAttendee.PersonalConsiderations.DietaryRequirements.length>0">
                                          <span v-for="(dietry, dietryindex) in ItemObj.PrimaryAttendee.PersonalConsiderations.DietaryRequirements" :key="dietryindex">{{getDietaryRequirement(dietry, ItemObj.PrimaryAttendee.PersonalConsiderations)}}<span v-if="dietryindex < ItemObj.PrimaryAttendee.PersonalConsiderations.DietaryRequirements.length - 1">, </span></span>
                                      </p>
                                      <p class="mb-2" v-if="showDietaryRequirement(ItemObj.PrimaryAttendee.PersonalConsiderations)">
                                          <span v-for="(dietryquestion, reqIndex) in formatDietaryRequirements(ItemObj.PrimaryAttendee.PersonalConsiderations)" :key="reqIndex">{{dietryquestion}}<span v-if="reqIndex < formatDietaryRequirements(ItemObj.PrimaryAttendee.PersonalConsiderations).length - 1">, </span></span>
                                      </p>
                                  </div>
                                  <p class="mb-2" v-if="ItemObj.PrimaryAttendee.Area"><b>Area: </b> {{ItemObj.PrimaryAttendee.Area}}</p>
                                  <p class="mb-2" v-if="ItemObj.PrimaryAttendee.Country"><b>Country: </b> {{ItemObj.PrimaryAttendee.Country}}</p>
                                  <p class="mb-2" v-if="ItemObj.PrimaryAttendee.HasVisaRequest != null"><b>Has Visa Request: </b> {{ItemObj.PrimaryAttendee.HasVisaRequest == true ? 'Yes' : 'No'}}</p>
                                  <p class="mb-1" v-if="ItemObj.PrimaryAttendee.CheckInDate"><b>Check-In and Check-Out Dates: </b></p>
                                  <p class="mb-2" v-if="ItemObj.PrimaryAttendee.CheckInDate">{{formattedDate(ItemObj.PrimaryAttendee.CheckInDate)}}, <span v-if="ItemObj.PrimaryAttendee.CheckOutDate">{{formattedDate(ItemObj.PrimaryAttendee.CheckOutDate)}}</span></p>
                                  <p class="mb-2" v-if="ItemObj.PrimaryAttendee.ActivityStartTime != null"><b>Spa Activity Start Time: </b>{{ ItemObj.PrimaryAttendee.ActivityStartTime }}</p>
                              </div>
                          </div>
                      </v-card-text>
                  </v-card>
                  <v-card class="height100 mt-4 details_box" v-if="ItemObj.GuestAttendee">
                      <v-card-title style="line-height: 1;" class="dialog_toolbar">Guest Attendee</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pl-2 pb-2 pr-2 pt-2">
                          <div class="form_content height100">
                              <div class="page_content_fields pl-5 pt-2">
                                  <p class="mb-1" v-if="ItemObj.GuestAttendee.BadgeFirstName"><b>Guest Badge First and Last Name: </b></p>
                                  <p class="mb-2" v-if="ItemObj.GuestAttendee.BadgeFirstName">{{ItemObj.GuestAttendee.BadgeFirstName}} {{ItemObj.GuestAttendee.BadgeLastName != null ? ItemObj.GuestAttendee.BadgeLastName : ''}}</p>
                                  <p class="mb-2" v-if="ItemObj.GuestAttendee.HasVisaRequest != null"><b>Has Visa Request: </b> {{ItemObj.GuestAttendee.HasVisaRequest == true ? 'Yes' : 'No'}}</p>
                                  <div v-if="ItemObj.GuestAttendee.PersonalConsiderations && ItemObj.GuestAttendee.PersonalConsiderations.DietaryRequirements && ItemObj.GuestAttendee.PersonalConsiderations.DietaryRequirements.length>0">
                                      <p class="mb-1"><b>Special Dietary Request:</b></p>
                                      <p class="mb-1" v-if="ItemObj.GuestAttendee.PersonalConsiderations.DietaryRequirements && ItemObj.GuestAttendee.PersonalConsiderations.DietaryRequirements.length>0">
                                          <span v-for="(dietry, dietryindex) in ItemObj.GuestAttendee.PersonalConsiderations.DietaryRequirements" :key="dietryindex">{{getDietaryRequirement(dietry, ItemObj.GuestAttendee.PersonalConsiderations)}}<span v-if="dietryindex < ItemObj.GuestAttendee.PersonalConsiderations.DietaryRequirements.length - 1">, </span></span>
                                      </p>
                                      <p class="mb-2" v-if="showDietaryRequirement(ItemObj.GuestAttendee.PersonalConsiderations)">
                                          <span v-for="(dietryquestion, reqIndex) in formatDietaryRequirements(ItemObj.GuestAttendee.PersonalConsiderations)" :key="reqIndex">{{dietryquestion}}<span v-if="reqIndex < formatDietaryRequirements(ItemObj.GuestAttendee.PersonalConsiderations).length - 1">, </span></span>
                                      </p>
                                  </div>
                                  <p class="mb-2" v-if="ItemObj.GuestAttendee.ActivityStartTime != null"><b>Spa Activity Start Time: </b>{{ ItemObj.GuestAttendee.ActivityStartTime }}</p>
                              </div>
                          </div>
                      </v-card-text>
                  </v-card>
                  <v-card class="height100 details_box buyinguest_box ma-0 mt-4" v-if="ItemObj.BuyInGuestAttendees && ItemObj.BuyInGuestAttendees.length>0">
                      <v-card-title style="line-height: 1;" class="dialog_toolbar">Buy-In Guest Attendees</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pl-2 pb-2 pr-2 pt-2">
                          <div class="form_content height100">
                              <div class="page_content_fields pl-5 pt-2">
                                    <ol>
                                        <li v-for="(attendee, guestindex) in ItemObj.BuyInGuestAttendees" :key="guestindex">
                                            <div>
                                                <div>
                                                    <div class="pt-2">
                                                        <p class="mb-1" v-if="attendee.BadgeFirstName"><b>Buy-In Guest Badge Names and Ages: </b></p>
                                                        <p class="mb-2" v-if="attendee.BadgeFirstName">{{attendee.BadgeFirstName}} {{attendee.BadgeLastName != null ? attendee.BadgeLastName : ''}} <span v-if="attendee.Age">({{attendee.Age}} {{attendee.Age > 1 ? 'Years' : 'Year'}})</span></p>
                                                        <div v-if="attendee.PersonalConsiderations && attendee.PersonalConsiderations.DietaryRequirements && attendee.PersonalConsiderations.DietaryRequirements.length>0">
                                                            <p class="mb-1"><b>Special Dietary Request:</b></p>
                                                            <p class="mb-1" v-if="attendee.PersonalConsiderations.DietaryRequirements && attendee.PersonalConsiderations.DietaryRequirements.length>0">
                                                                <span v-for="(dietry, dietryindex) in attendee.PersonalConsiderations.DietaryRequirements" :key="dietryindex">{{getDietaryRequirement(dietry, attendee.PersonalConsiderations)}}<span v-if="dietryindex < attendee.PersonalConsiderations.DietaryRequirements.length - 1">, </span></span>
                                                            </p>
                                                            <p class="mb-2" v-if="showDietaryRequirement(attendee.PersonalConsiderations)">
                                                                <span v-for="(dietryquestion, reqIndex) in formatDietaryRequirements(attendee.PersonalConsiderations)" :key="reqIndex">{{dietryquestion}}<span v-if="reqIndex < formatDietaryRequirements(attendee.PersonalConsiderations).length - 1">, </span></span>
                                                            </p>
                                                        </div>
                                                        <p class="mb-2" v-if="attendee.ActivityStartTime != null"><b>Spa Activity Start Time: </b>{{ attendee.ActivityStartTime }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ol>
                              </div>
                          </div>
                      </v-card-text>
                  </v-card>
                  <v-card class="height100 details_box mt-4" v-if="ItemObj.ActivityList && ItemObj.ActivityList.length>0">
                      <v-card-title style="line-height: 1;" class="dialog_toolbar">Activities</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pl-2 pb-2 pr-2 pt-2">
                          <div class="form_content height100">
                              <div class="page_content_fields pl-5 pt-2">
                                  <ol>
                                      <li class="mb-2" v-for="(activity, activityindex) in ItemObj.ActivityList" :key="activityindex">{{activity}}</li>
                                  </ol>
                              </div>
                              <div class="page_content_fields pl-5 pt-2" v-if="ItemObj.NonHostedActivityList && ItemObj.NonHostedActivityList.length>0">
                                    <div class="mb-3" style="font-size: 16px; font-weight: 500; color:rgba(0,0,0,.87);">Non-Hosted Activity</div>
                                  <ol>
                                      <li class="mb-2" v-for="(activity, activityindex) in ItemObj.NonHostedActivityList" :key="activityindex">{{activity}}</li>
                                  </ol>
                              </div>
                          </div>
                      </v-card-text>
                    </v-card>     
                  </v-card-text>
                </v-card>

                <!-- <v-footer v-if="$root.Envirenment != 3" class="pa-3" style="position: fixed;width: 100%;bottom: 0;background:#fff">
                    <v-btn block color="primary" dark @click="$root.fn_openChatView('instantchat', attendeeInfo.AttendeeID)">Start Chat</v-btn>
                </v-footer> -->
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
  
        
    </div>
  </template>
  
  <script>
  import InfiniteLoading from 'vue-infinite-loading';
  import axios from 'axios';
  // import dialogAttendeeInfo from '../winner_attendee_profile'
  // import { CometChat } from "@cometchat-pro/chat";
  const moment = require('moment');
  var controller = null;
  
  // const controller = new AbortController();
  
    export default {
      data: () => ({
        loading:false,
        winners:[],
        infiniteId: +new Date(),
        pageOffset:0,
        searchValue:'',
        timeoutid:null,
        error:false,
        unreadMessageCount:0,
        IsShowGuest: true,
        contentDialog: false,
        ItemObj: null,
        AttendeeRegistrationID: null
      }),
      components: {
        InfiniteLoading,
        // 'dialog-attendee-info':dialogAttendeeInfo
      },
      methods:{
        fn_debounceSearch: function(){
          console.log('debounce');
          if (this.timeoutid != null){
            clearTimeout(this.timeoutid);
          }
  
          this.timeoutid = setTimeout(() => { 
            this.error = false;
            this.pageOffset = 0;
            this.winners = [];
            this.infiniteId = +new Date();
          },500);
        },

        formattedDate(date) {
          if(date)
            return moment(date).format('MMMM DD, YYYY')
        },
  
        infiniteHandler($state) { 
          this.error = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
                this.error = true; 
                this.$root.fn_showToast('exception');
              }
              else{
                  if(controller){
                    controller.abort();
                    console.log('Fetch aborted');
                  }
                  
                  controller = new AbortController();
  
                  var headersObj = {
                    headers: { 
                          'Authorization': 'bearer ' +  token,
                        }
                    };
  
                  let postObj = {}
                  postObj.keywords = this.searchValue;
                  postObj.IsGuestSearchEnable = this.IsShowGuest;
  
                  console.log(JSON.stringify(postObj));
  
                  // axios.post(this.$root.baseUrl + "/api/mobileapp/admin/onsiteview/attendee/list", postObj, headersObj, {timeout:30000}, {signal: controller.signal})
                  axios.post(this.$root.baseUrl + "/api/mobileapp/admin/onsiteview/attendee/list?offset="+this.pageOffset+"&limit=30", postObj, headersObj, {timeout:30000}, {signal: controller.signal})
                  .then(response => {
                      console.log(response);
                      if(response.data.Count > this.winners.length){
                        for(let i=0; i<response.data.ListData.length; i++){
                            this.winners.push(response.data.ListData[i]);
                        }
                        $state.loaded();
                      }
                      else{
                        $state.complete();
                      }
                      controller = null;
                      this.fn_photoAuthThumbnail();
                      this.pageOffset = this.winners.length;
                  }).catch(e => {
                      console.log(e);
                      if(e.response.data == "Token Expired"){
                        this.fn_debounceSearch();
                      }
                      else{
                        let toastMsg = e && e.message ? e.message : 'exception';
                        this.$root.fn_showToast(toastMsg);
                        this.error = true;
                      }
                  })
              }
          })
          
        },
  
        fn_gotoChatPage: function(attendeeregistrationid){
          this.contentDialog = true;
          this.AttendeeRegistrationID = attendeeregistrationid;
          this.fn_getAttendeeInfo();
        },

        fn_abbreviatedName: function(str){
            if(!str){
              return ''
            }
            //let words = str.trim().split(' ');
            //words = words.replace(/ +(?= )/g,'');
            let words = str.trim().replace(/ +(?= )/g,'').split(' ');

            if(words.length > 1){
                return words[0][0].toUpperCase() + words[1][0].toUpperCase();    
            }
            else{
                return words[0][0].toUpperCase();
            }
        },

        fn_isShowGuest: function(){
          this.fn_debounceSearch();
        },

        async fn_photoAuthThumbnail() {
          let self = this;
          // this.loading = true;
          // this.error = false;

          const batchSize = 5; // Size of each batch

          // Filter winners to get those that have an ImageUrl and are not already base64
          const winnersWithImages = self.winners.filter(winner => winner.ImageUrl && !winner.ImageUrl.startsWith('data:image/'));

          // If there are no winners with valid ImageUrl, return early
          if (winnersWithImages.length === 0) {
            //   this.loading = false;
              return;
          }

          // Function to process a batch of winners
          const processBatch = async (batch) => {
              try {
                  // Prepare the list of AttendeeIds and ImageUrls to send in the POST request
                  const imagePayload = batch.map(winner => ({
                      AttendeeID: winner.AttendeeID,
                      PhotoUrl: winner.ImageUrl
                  }));

                  const token = await new Promise((resolve, reject) => {
                      this.$root.fn_getToken((token) => {
                          if (token === 'error') {
                              reject('Token error');
                          } else {
                              resolve(token);
                          }
                      });
                  });

                  console.log(token + " Token Called");

                  const headersObj = {
                      headers: { 
                          'Authorization': 'Bearer ' + token,
                      }
                  };

                  console.log(self.$root.baseUrl);

                  // Send the POST request with the array of AttendeeId and ImageUrl pairs
                  const response = await axios.post(
                      self.$root.baseUrl + '/api/mobileapp/Document/Download/Url/list', // Change to your POST endpoint
                      imagePayload,          // Send array of AttendeeId and ImageUrl pairs
                      headersObj,
                      { timeout: 30000 }
                  );

                  console.log(response.data);

                  // Update winners' ImageUrl based on the response, matching AttendeeId
                  response.data.forEach(respItem => {
                      const matchedWinner = self.winners.find(winner => winner.AttendeeID === respItem.AttendeeID);
                      if (matchedWinner) {
                          matchedWinner.ImageUrl = 'data:image/png;base64,' + respItem.Base64;
                          console.log(matchedWinner.ImageUrl);
                      }
                  });

                  self.$forceUpdate();
              } catch (e) {
                //   self.error = true;
                  console.log(e);
                  throw e; // Stop further processing on error
              }
          };

          try {
              if (winnersWithImages.length <= 5) {
                  // If the number of items with ImageUrl is less than or equal to 5, process them in one call
                  await processBatch(winnersWithImages);
              } else {
                  // Otherwise, split them into batches of 5
                  for (let i = 0; i < winnersWithImages.length; i += batchSize) {
                      const batch = winnersWithImages.slice(i, i + batchSize);
                      await processBatch(batch); // Process each batch sequentially
                  }
              }
          } catch (error) {
              console.log('Batch processing failed', error);
          } finally {
            //   this.loading = false;
              this.error = false;
          }
        },

        getDietaryRequirement(dietry, item) {
          if (dietry === 'Other') {
              return 'Other: ' + item.OtherDietaryRequirements;
          }
          else {
              return dietry;
          }
        },

        showDietaryRequirement(item) {
          if (item.DietaryRequirements && item.DietaryRequirements.length > 0 && item.HalalCertified) {
              return true
          }
          else if (item.DietaryRequirements && item.DietaryRequirements.length > 0 && item.IndianVegeterian) {
              return true
          }
          else if (item.DietaryRequirements && item.DietaryRequirements.length > 0 && item.KosherCertified) {
              return true
          }
          else if (item.DietaryRequirements && item.DietaryRequirements.length > 0 && item.AllergyDetail) {
              return true
          }
          else {
              return false
          }
        },

        formatDietaryRequirements(personalConsiderations) {
          const { HalalCertified, KosherCertified, IndianVegeterian, AllergyDetail } = personalConsiderations;

          // Start with the base dietary requirements
          let requirements = [];

          // Add additional requirements
          if (HalalCertified !== null) {
              requirements.push(HalalCertified === true ? 'Required Halal Certified Meals: Yes' : 'Halal Certified Meals: No');
          }

          if (IndianVegeterian !== null) {
              requirements.push(IndianVegeterian === true ? 'Indian Vegetarian Meals: Yes' : 'Indian Vegetarian Meals: No');
          }

          if (KosherCertified !== null) {
              requirements.push(KosherCertified === true ? 'Required Kosher Certified Meals: Yes' : 'Kosher Certified Meals: No');
          }

          if (AllergyDetail) {
              requirements.push('Allergy: ' + AllergyDetail);
          }

          // Filter out any null or undefined values (just in case)
          return requirements.filter(item => item);
        },

        fn_getAttendeeInfo: function(){
          this.ItemObj = null;
          this.contentDialog = true;
          this.loading = true;
          this.error = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
              this.loading = false;
              this.error = true;
              this.$root.fn_showToast('exception');
              }
              else{
                  var headersObj = {
                  headers: {
                          'Authorization': 'bearer '+token,
                      }
                  };

                  axios.get(this.$root.baseUrl + "/api/mobileapp/admin/onsiteview/attendee/details?AttendeeRegistrationID="+this.AttendeeRegistrationID, headersObj, {timeout:30000})
                  .then(response => {
                      console.log(response);
                      this.loading = false;
                      this.ItemObj = response.data;
                      // this.fn_photoAuth();
                  }).catch(e => {
                      console.log(e);
                      this.loading = false;
                      this.error = true;
                      let toastMsg = e && e.message ? e.message : 'exception';
                      this.$root.fn_showToast(toastMsg);
                  })
              }
          })
        }
  
      }
    }
  </script>